import React from 'react';

import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import { AppContext } from 'src/contexts/appContext';

import './TerritoryFlag.scss';

interface ITerritoryFlag {
    territoryCode: string;
    showTerritoryCode?: boolean;
    showTerritoryName?: boolean;
    isGridDisplay?: boolean;
}

export const TerritoryFlag = ({
    territoryCode,
    showTerritoryCode = true,
    showTerritoryName = true,
    isGridDisplay = false
}: ITerritoryFlag) => {
    const imgUrl = `https://m.media-amazon.com/images/G/01/flags/rectangular/${territoryCode.toLowerCase()}.png`;
    const textType = isGridDisplay ? 'b200' : 'b300';
    const { metadata } = React.useContext(AppContext);
    const territories = Object.values(metadata.territoryMapping);

    const getTerritoryNameByCode = () => {
        return territories.find((territory) => territory.territoryCode === territoryCode)?.territoryName;
    };

    return (
        <Row alignmentVertical="center" spacing="none">
            <img width="40px" height="20px" src={imgUrl} className="territory-flag" alt="territory flag" />
            {showTerritoryCode && <Text type={textType}>{territoryCode}</Text>}
            {showTerritoryCode && showTerritoryName && <Text type={textType}>&nbsp;-&nbsp;</Text>}
            {showTerritoryName && <Text type={textType}>{getTerritoryNameByCode()}</Text>}
        </Row>
    );
};
